/**
 * @file additiveLabel.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-16
 * @modified 2026-09-16
 *
 * How a product reads with its additives, everywhere it is written out:
 *
 *   "Product Name + Additive (Code)"
 *
 * with the code dropped when it says the same thing as the name — one
 * supplier's additive is literally code "Spice", name "Spice" — or when there
 * is none, as for a free-text additive. Several read "A + B (1) + C".
 *
 * The server's copy is utils/additiveLabel.js at the project root; keep the two
 * in step.
 */

const clean = (v) => String(v == null ? '' : v).trim();

/** "Rumitech (083)", "Spice", "C16 2% (079)". */
export function additiveLabel(additive) {
  if (!additive) return '';
  const name = clean(additive.additive_name ?? additive.name);
  const code = clean(additive.additive_code ?? additive.code);
  if (!name) return code;
  if (!code || code.toLowerCase() === name.toLowerCase()) return name;
  return `${name} (${code})`;
}

/** "Dairy 18 + Rumitech (083) + Spice" — the product alone when it has none. */
export function withAdditives(productName, additives) {
  const labels = (Array.isArray(additives) ? additives : []).map(additiveLabel).filter(Boolean);
  const name = clean(productName);
  return labels.length ? [name, ...labels].filter(Boolean).join(' + ') : name;
}


